module.exports = __webpack_public_path__ + "static/media/Sq1.7bad5cca.svg";